import { Pipe, PipeTransform } from '@angular/core';
import { WorkFlowTaskInfo } from '../models/form/work-flow-task-info.model';

@Pipe({
  name: 'historyFilter',
})
export class HistoryFilterPipe implements PipeTransform {
  transform(items: WorkFlowTaskInfo[]): WorkFlowTaskInfo[] {
    return items.filter(
      (item, index) => item.hiddenTrigger || !item.hide || index === 0
    );
  }
}
